import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';

export const TRANSITION_DURATION = '300ms';
export const TRANSITION_EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';

/**
 * A button that is hidden (zero-width, transparent) when `data-visible` is
 * `"false"` and smoothly expands into view when `data-visible` is `"true"`.
 *
 * We drive the animation entirely through a data-attribute so every instance
 * can be given a different `transitionDelay` via the `sx` prop for a
 * staggered fan-out effect.
 */
export const ExpandingButton = styled(Button)(() => ({
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    minWidth: 0,

    /* ---- collapsed (default) ---- */
    maxWidth: 0,
    opacity: 0,
    transform: 'scaleX(0)',
    paddingLeft: 0,
    paddingRight: 0,
    marginLeft: 0,
    marginRight: 0,

    transition: [
        `max-width ${TRANSITION_DURATION} ${TRANSITION_EASING}`,
        `opacity ${TRANSITION_DURATION} ${TRANSITION_EASING}`,
        `transform ${TRANSITION_DURATION} ${TRANSITION_EASING}`,
        `padding ${TRANSITION_DURATION} ${TRANSITION_EASING}`,
        `margin ${TRANSITION_DURATION} ${TRANSITION_EASING}`
    ].join(', '),

    /* ---- expanded ---- */
    '&[data-visible="true"]': {
        maxWidth: 160,
        opacity: 1,
        transform: 'scaleX(1)',
        paddingLeft: 16,
        paddingRight: 16,
        marginLeft: 4,
        marginRight: 4
    }
}));
